import { MenuItem, TextField } from "@mui/material";
import { useGetWebhookProvidersQuery } from "features/integrationsBeta/platformEnums";
import { useEffect } from "react";

interface Props {
  name: string;
  onNameChange: (name: string) => void;
  provider: string;
  onProviderChange: (provider: string) => void;
}

/**
 * Webhook trigger fields shared by the Settings create dialog and the
 * registration wizard: just an optional label and the provider. The
 * Secret-Key connection is NOT chosen here - the backend auto-provisions a
 * dedicated WEBHOOK connection and generates the secret on create.
 */
export default function WebhookTriggerFields({
  name,
  onNameChange,
  provider,
  onProviderChange,
}: Props) {
  const { data: providers = [] } = useGetWebhookProvidersQuery();

  // Default to the first provider once the list loads (callback deliberately
  // not a dependency - parents recreate it per render).
  useEffect(() => {
    if (!provider && providers.length) {
      onProviderChange(providers[0].value);
    }
  }, [provider, providers]);

  return (
    <>
      <TextField
        size="small"
        label="Name (optional)"
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        helperText="Label to tell sibling triggers apart, e.g. 'Paycom - new hires'."
      />

      <TextField
        select
        size="small"
        label="Provider"
        value={provider}
        onChange={(e) => onProviderChange(e.target.value)}
        helperText="A secret key is generated automatically when you create the trigger."
      >
        {providers.map((p) => (
          <MenuItem key={p.value} value={p.value}>
            {p.label}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
}
